import { InitialConfigType, InitialEditorStateType } from "@lexical/react/LexicalComposer";
import { Typography } from "@mui/material";
import { Controller, ControllerProps, FieldValues, get, Path, useFormContext } from "react-hook-form";

import { EditLexical } from "@/components/elements/lexical/components/EditLexical";

export interface LexicalEditorProps extends Partial<InitialConfigType> {
  initialState?: InitialEditorStateType;
  renderPropOnChange?: (newValue: string) => void;
  setValue?: (key: string, mentioned_account_ids: number[] | string) => void;
  mentionEndpoint?: string;
  includeHtml?: boolean;
  placeholder?: string;
  editable?: boolean;
}

export type FormLexicalEditorProps<TFormValues extends FieldValues> = Pick<ControllerProps, "rules"> &
  LexicalEditorProps & {
    name: Path<TFormValues>;
  };

export function LexicalEditor<TFormValues extends FieldValues>({
  name,
  rules,
  ...rest
}: FormLexicalEditorProps<TFormValues>) {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange } }) => (
        <>
          <EditLexical {...rest} initialState={value} renderPropOnChange={onChange} setValue={setValue} />
          {error && error.message && <Typography color="error">{error.message}</Typography>}
        </>
      )}
    />
  );
}
